/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import * as stagesCase from "../../../Stages/StagesCase";
import { stageFormDefinition as contractStageFormDefinition } from "../contract/stageFormDefinition";
import { FormDefinition } from "../../../../types/ProductService/ProductService";
import { BackofficeUser } from "../../../../types/BackofficeUser";
import { DataLeakContract } from "../../../../types/Products/ContractLaw/DataLeakContract";

export function stageFormDefinition(product: DataLeakContract, currentUser?: BackofficeUser): ReturnType<FormDefinition<DataLeakContract>> {
  return {
    [stagesCase.STAGE_CREATED]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_CREATED],
    [stagesCase.STAGE_DATA_COMPLETED]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_DATA_COMPLETED],
    [stagesCase.STAGE_WAITING_FOR_FEEDBACK]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_DATA_COMPLETED],
    [stagesCase.STAGE_DATA_COMPLETED_LAWFIRM]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_DATA_COMPLETED_LAWFIRM
      ],
    [stagesCase.STAGE_CHECKED]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_CHECKED],
    [stagesCase.STAGE_IN_PROGRESS]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_IN_PROGRESS],
    [stagesCase.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_EXTRAJUDICIAL_COMMUNICATION_SENT
      ],
    [stagesCase.STAGE_EXTRAJUDICIAL_REACTION_RECEIVED]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_EXTRAJUDICIAL_REACTION_RECEIVED
      ],
    [stagesCase.STAGE_ACTION_REQUIRED]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_ACTION_REQUIRED
      ],
    [stagesCase.STAGE_PREPARE_LAWSUIT]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_PREPARE_LAWSUIT
      ],
    [stagesCase.STAGE_LAWSUIT]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_LAWSUIT],
    [stagesCase.STAGE_TRIAL]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_LAWSUIT],
    [stagesCase.STAGE_EVALUATE_JUDGEMENT]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_EVALUATE_JUDGEMENT
      ],
    [stagesCase.STAGE_LAWSUIT_COMPLETED]: contractStageFormDefinition(product, currentUser)[
      stagesCase.STAGE_LAWSUIT_COMPLETED
      ],
    [stagesCase.STAGE_COMPLETED]: contractStageFormDefinition(product, currentUser)[stagesCase.STAGE_COMPLETED]
  };
}
